export const NewTransfer = {
  Portfolio: 'portfolio',
  BalanceAndTransaction: 'balanceAndTransaction',
};

export const PROPERTY_TYPES = {
  INITIAL: 'initial',
  SECONDARY: 'secondary',
};
export const PROPERTY_TYPE_NAME = {
  [PROPERTY_TYPES.INITIAL]: 'Initial Offering',
  [PROPERTY_TYPES.SECONDARY]: 'Realbricks Market',
};

export const PROPERTY_SUB_TYPE = {
  VACATION: 'Vacation rental',
  SINGLE: 'Single family',
  MULTI: 'Multifamily',
};

export const RETURN_MODEL = {
  avg: 'average',
  low: 'lowest',
  high: 'highest',
};

export const TOOLTIP_TEXT = {
  PURCHASE_PRICE:
    'The price paid by Realbricks to acquire the property. This does not include the offering fees or cash reserve, as applicable for the specific property.',
  PROPERTY_STATUS_RENTED: 'This property is currently rented.',
  PROPERTY_STATUS: 'This property is currently listed/marketed for rent on public rental sites including Zillow.',
  FIRST_DIVIDEND_DATE:
    'The initial dividend date is the expected date for the first quarterly dividends. Any dividend payments are paid quarterly. Based on when the property was financed, there will be times when the first dividend payment will only cover a partial quarter.',
  FIRST_DIVIDEND_YIELD: `The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a quarterly basis. The dividend percentage is calculated by dividing the total dividend payment (to be split amongst share owners) by the total property purchase price (raised during the initial offering period). The dividend payment you receive will be proportional to your ownership of the property.`,
  RENTAL_DEMAND: `How often are rentals booked throughout the year? By using a combination of annual occupancy and listing growth rates, this metric shows the relative travel demand in the Realbricks market.

  High Score = High Travel Demand`,
  REVENUE_GROWTH: `Did properties earn more this month then they did in the same month last year? This is calculated by looking at the change in year-over-year RevPAR for properties that received bookings in both time periods.

  High Score = Increasing Revenue per Property`,
  SEASONALITY: `How much does travel demand differ between peak season and low season? This is the percentage difference between the minimum and maximum monthly RevPAR in the past year.

  High score = Low seasonality`,
  REGULATION: `An algorithm that looks at host and property behavior to identify signs of regulation.

  High score = Low regulation`,
  INVESTIBILITY: `Is this a good city for short-term rental investment property? Compares the cost of homes in the city to the average short-term rental income of full time rental properties.

  High score = Good Investment Opportunity`,
  MORTGAGE_AMOUNT:
    'The amount of the total expense funded by a long-term mortgage loan. To provide investors with leverage, mortgages are placed on the property.',
  MORTGAGE_INTREST_RATE: `The interest rate for the home loan used to obtain the property. The investors are not liable for the debt, as the loan is non-recourse. The rental income from the property covers the interest expenses.`,
  OFFERING_PURCHASE_PRICE: `The price paid to attain the property. Offering fees or cash reserve is not included.`,
  IMPROVEMENTS: `The amount of money set aside for property improvements and a cash reserve balance for maintaining long-term operations.`,
  CLOSING_OFFERING_HOLDING_COSTS: `These expenses include property closing costs, financing the property before or after closing, and offering the shares for investment.`,
  RB_SOURCING_FEE: `This is the fee Realbricks charges for our work associated with procuring the property and getting it ready for investment. This one-time fee is already included in the equity raised from investors and the share price.`,
  RB__AUM_QUARTER: `The Realbricks AUM fee is paid quarterly and based on an annual percentage of the property purchase price. This fee covers a range of services including tax preparation, investor support, financial oversight and overseeing the property management and is paid from the rental income.`,
  RB__AUM_MONTHLY: `The Property Management fees are paid monthly to the property management partner from the rental income and helps cover the operational expenses of the rental unit. Competitive rates are negotiated with our property management partners for each individual offering.`,
  RECURRING_FEE_NOTE: `Note: Shareholders will not be invoiced for these fees; the fees will be deducted from the rental revenue.`,
  PROPERTY_MANAGEMENT_FEES: `Property Management Fees are paid monthly to the property management partner from the rental income and helps cover the operational expenses of the rental unit. Competitive rates are negotiated with our property management partners for each individual offering.`,
  AVERAGE_TIME_TO_RENT: `The amount of time required to sign the first tenant lease varies depending upon several factors including seasonality and whether or not the property is in need of any sort of renovation. Generally, the average time to lease is around 45 days and has ranged from a minimum of 7 days to over 90 days.`,
  OCCUPANCY_RATE: `The occupancy rate is the ratio of used or rented space to the total amount of available space.`,
  HISTORICAL_PERFORMANCE: (location) =>
    `Based on data provided by independent, third-party data providers, including Zillow and/or HouseCanary the Historical Performance is the estimated annual average property appreciation over the last 10 & 20 years for the ${location} Realbricks market.`,
};

export const PIN_VERIFICATION_TYPES = {
  LOGIN: 'login',
  MARKET_PLACE: 'marketPlace',
  PROFILE_EDIT: 'profileEdit',
};

export const NOTIFICATION_MESSAGES = {
  WARN_DWOLLA_PENDING: 'Your account is still in-review, you will be informed after completion of your account review.',
  PLAID_LINK_ACCOUNT_ERROR:
    'We are currently experiencing an issue linking your bank account via Plaid. Please ensure you have checked all the required boxes during the bank addition process and try again later. If the problem persists, please contact support@realbricks.com team for assistance.',
};
